import { render, staticRenderFns } from "./MiniScenario.vue?vue&type=template&id=1ded026d&scoped=true&"
import script from "./MiniScenario.vue?vue&type=script&lang=js&"
export * from "./MiniScenario.vue?vue&type=script&lang=js&"
import style0 from "./MiniScenario.vue?vue&type=style&index=0&id=1ded026d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ded026d",
  null
  
)

export default component.exports